// Tiny app-wide event bus (Vue 2). Used to decouple the click-to-call button
// (confirmation page) from the global softphone that owns the WebRTC session.
import Vue from "vue";

const bus = new Vue();

export default bus;
